export const auLogoURL = 'https://media.artifactuprising.com/media/logo/prod/logo.svg';
type SchemaOrgTags = {
  '@context': string;
  brand: {
    '@type': string;
    name: string;
    url: string;
    logo: string;
  };
};
export function getBaseSchemaOrgTags(): SchemaOrgTags {
  return {
    '@context': 'http://schema.org',
    brand: {
      '@type': 'Brand',
      name: 'Artifact Uprising',
      url: 'https://www.artifactuprising.com',
      logo: auLogoURL
    }
  };
}